<template>
	<div>
		<div class="md-layout">
			<entity-card
				v-bind="{ schema, readEntity, deleteEntity, createEntity, updateEntity }" @openUpload="showModal = true" :entity.sync="entity">
			</entity-card>
		</div>
	</div>
</template>

<script>
	import Podcast from "@/models/podcast.model.vue"
	import EntityCard from "@/components/Espresso/EntityCard.vue"
	import ImportModal from "@/components/Espresso/ImportModal.vue"

	export default {
		components: {
			EntityCard,
			ImportModal,
		},
		data() {
			return {
				entity: {
					id: this.$route.params.id,
				},
				schema: Podcast.getSchema(),
				name: "Enviar video",
				showModal: false,
			}
		},
		methods: {
			async createEntity(entity) {
				this.entity = await Podcast.create(entity);
				this.$router.replace(`/podcast/${this.entity.id}`);
				return this.entity;
			},
			async readEntity(entityId) {
				return Podcast.getInfo(entityId);
			},
			async updateEntity(entity) {
				const dataToUpdate = Object.assign({}, entity);
				return Podcast.updateInfo(dataToUpdate);
			},
			async deleteEntity(entityId) {
				await Podcast.remove(entityId);
				this.$router.push("/podcasts");
			},
		},
	};
</script>
